<app-loading-spinner
    [isLoading]="(daveningService.loading()) || !finishedLoading"></app-loading-spinner>
<div *ngIf="davenfors && finishedLoading" class="container">
    <div class="text-center" *ngIf="davenfors.length<1 && finishedLoading">
        <app-empty-list whatIsMissing="names for davening"></app-empty-list>
    </div>
    <div class="div-names" *ngIf="davenfors.length>0">

        <table class="table table-responsive">
            <tr>
                <th>Category</th>
                <th>English Name</th>
                <th>Hebrew Name</th>
                <th>Email</th>
                <th></th>
            </tr>

            <tr *ngFor="let davenfor of davenfors">

                <td>{{davenfor.category | viewCategory}}</td>
                <td>
                    <!--English name, and spouse's English name if applicable-->
                    <span>{{davenfor.nameEnglish | titlecase}}</span>
                    <span
                        *ngIf="davenfor.category=='banim'&&davenfor.nameEnglishSpouse"><br>{{davenfor.nameEnglishSpouse}}</span>
                </td>
                <td>
                    <!--Hebrew name, and spouse's Hebrew name if applicable -->
                    <span>{{davenfor.nameHebrew}}</span>
                    <span
                        *ngIf="davenfor.category=='banim'&&davenfor.nameHebrewSpouse"><br>{{davenfor.nameHebrewSpouse}}</span>
                </td>
                <td>{{davenfor.userEmail}}</td>
                <td class="button-column">
                    <button class="menu-button btn btn-warning" (click)="onEdit(davenfor)">Edit</button>
                    <button class="menu-button btn btn-danger"
                        (click)="onDelete(davenfor)">Delete</button>
                </td>
            </tr>
        </table>

    </div>

    <div class="row">
        <div class="col-2 offset-3">
            <button class="btn btn-info btn-lg" (click)="onAddName()">+ Add Name</button>
        </div>
        <div class="col-2">
            <button class="btn btn-success btn-lg" (click)="onRefresh()">Refresh Names</button>
        </div>
    </div>
</div>